import React from "react";
import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Circle, CircleOutlined, PersonOutline } from "@mui/icons-material";

// Resolve a usable image URL from whatever shape the item comes in as
// ({img}, {url}, or a bare string) — mirrors the tolerant handling used
// by the mobile event photo gallery so a differently-shaped item never
// silently renders as a blank/broken slide.
const resolveSrc = (item) => (typeof item === "string" ? item : item?.img || item?.url) || null;

export const ImageSwiper = ({ imgs }) => {
  const [page, setPage] = React.useState(0);
  const [brokenIdx, setBrokenIdx] = React.useState({});
  const slides = (imgs ?? [])
    .map((item) => resolveSrc(item))
    .filter(Boolean);

  if (slides.length === 0) {
    return (
      <Box sx={{
        width: "100%", height: 500, display: "flex", alignItems: "center",
        justifyContent: "center", background: "#EEF0F4",
      }}>
        <PersonOutline sx={{ fontSize: 64, color: "#B7BFCC" }} />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: 550, overflow: "hidden" }}>
      <Swiper
        onSlideChange={(swiper) => setPage(swiper.activeIndex)}
        spaceBetween={0}
        slidesPerView={1}
        style={{ height: 500 }}
      >
        {slides.map((src, i) => (
          <SwiperSlide key={i}>
            {brokenIdx[i] ? (
              <Box sx={{
                width: "100%", height: 500, display: "flex", alignItems: "center",
                justifyContent: "center", background: "#EEF0F4",
              }}>
                <PersonOutline sx={{ fontSize: 64, color: "#B7BFCC" }} />
              </Box>
            ) : (
              <Box
                component="img"
                src={src}
                alt=""
                onError={() => setBrokenIdx((prev) => ({ ...prev, [i]: true }))}
                sx={{
                  width: "100%",
                  height: 500,
                  objectFit: "cover",
                }}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>

      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
      {slides.map((src, i) => (
        i === page ?
          <Circle key={i} />
          :
          <CircleOutlined key={i} />

        ))}
      </Box>
    </Box>
  );
};